/**
 * Redirects the user to the Source Linker page for a given person ARK identifier.
 * Opens the Source Linker in a new browser tab if possible, otherwise navigates in the current tab.
 *
 * @param {string} personArk - The ARK identifier of the person to link sources for.
 */
export const redirectToSourceLinker = (personArk) => {
  const arkPath = `/ark:/61903/${personArk}`
  const sourceLinkerUrl = `/search/linker?ark=${encodeURIComponent(arkPath)}&sourceType=rii`
  window.open(sourceLinkerUrl, '_blank') || window.location.assign(sourceLinkerUrl)
}
